import React, { useEffect } from "react";
import Typewriter from 'typewriter-effect/dist/core';
import profileAvatar from "../asset/logo.png";
import PersonalData from "../../Data/DevsData";
import classes from "./home.module.css";
import { autoTypeData } from "../../Data/DevsData";
import { useState } from 'react';
import SocialLinks from "../SocialLinks/SocialLinks";
import { useSelector } from "react-redux";
import ReactiveButton from 'reactive-button';

function Home(props) {
    const [state, setState] = useState('idle');

    const onClickHandler = () => {
      setState('loading');
  
      // send an HTTP request
      setTimeout(() => {
       setState('Done');
        // Redirect to a custom URL after success
       
       window.location.href = 'https://apps.microsoft.com/store/detail/firebrowseralpha/9N8V89Z21TDC?hl=eng-us';
        
    }, 2000);
    };


    const nonThemeColor = useSelector(state => state.nonThemeColor);
    const uiColor=useSelector(state=>state.uiColor);
    function handleTyper() {
        let textItems = autoTypeData;
        var autoTyper = document.getElementById('typer');
        new Typewriter(autoTyper, {
            strings: textItems,
            autoStart: true,
            pauseFor: 1000,
            loop: true,
        });
    }
    useEffect(
        handleTyper
    ,[]);
    return (
        <main>
            <div className={classes.homeContent}>
                <h1 className={classes.greeting}>
                    Hi There !
                </h1>
                <h2>Whe Are &nbsp;<span id="name" style={{ color: uiColor }}>{PersonalData.firstName}&nbsp;{PersonalData.lastName}</span></h2>
                <h3 style={{ color: nonThemeColor }}>
                    {PersonalData.nickName}
                </h3>
                <div className={classes.autoText}>
                    Coded With &nbsp; <span id="typer" style={{ color: uiColor }}></span>
                </div>
                <p className={classes.connectText}>Feel free to <span style={{ color: uiColor }}>connect</span> with us.</p>
                <SocialLinks className={classes.links} />
                <ReactiveButton
              buttonState={state}
      idleText="Microsoft Store"
      loadingText="Redirecting..."
      successText="Done"
      onClick={onClickHandler}
      />
            </div>
            <div className={classes.avatarImage}>
                <img src={profileAvatar} alt="" srcSet="" />
            </div>         
        </main>
       
    )
}
export default Home;